import { useMemo } from "react";
import { Stack } from "@mui/material";
import WGRTable from "./actualTable";

export default function WGRViewer({ rows}) {
      
  return (
    <Stack >


{/* THIS IS WHERE WGRTable SHOULD BE */}
      <WGRTable
        rows={rows}
       
      />

      


    </Stack>
  );
}